module.exports = __webpack_public_path__ + "img/ajax-logo-icon.580de33a.png";